<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex xs2 md2>
                <v-btn color="green" dark text @click="createLink()">嘉好-信貸申請</v-btn>
            </v-flex>
        </v-layout>
        <v-layout mt-2>
            <v-flex xs5 sm5 md5>
                <date-picker :date.sync="search.startDate" />
            </v-flex>
            <v-flex xs5 sm5 md5>
                <date-picker :date.sync="search.endDate" />
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <table-view :columnKeys="columnKeys" :items="items" :loading="loading" :total-items="totalItems" @changePage="changePage" @cellEvent="cellEvent" @handleLoadData="reset">
            </table-view>
        </v-layout>

        <v-dialog v-model="selectDialog.visible" no-click-animation max-width="60%">
            <v-card>
                <v-card-title>{{ selectDialog.title }}</v-card-title>
                <v-card-text>
                    <v-flex>
                        <v-select :items="typeKeys" item-text="text" item-value="key" v-model="selectDialog.type"></v-select>
                    </v-flex>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red" dark text @click="selectDialog.cancel">取消</v-btn>
                        <v-btn class="primary" dark text @click="selectDialog.confirm">確定</v-btn>
                    </v-card-actions>
                </v-card-text>
            </v-card>
        </v-dialog>
        <alert-view :visible="messageDialog.visible" :title="messageDialog.title" :content="messageDialog.content" :show-cancel="messageDialog.showCancel" @confirmEvent="messageDialog.confirm" @cancelEvent="messageDialog.cancel"></alert-view>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MobileDetect from "mobile-detect";
import AlertView from "@/components/AlertView";
import TableView from "@/components/TableView";
import DatePicker from "@/components/DatePicker";

export default {
    name: "CreditLoanList",
    components: {
        AlertView,
        TableView,
        DatePicker,
    },
    data() {
        return {
            items: [],
            loading: false,
            totalItems: 0,
            pageIndex: 0,
            limit: 0,
            search: {
                keyword: "",
                placeholder: "搜尋單號、店家、業務",
                startDate: "2021-01-01",
                endDate: "2121-01-01",
                searchKey: "",
            },
            selectDialog: {
                visible: false,
                title: "轉換申請書",
                type: 0,
                confirm: () => {},
                cancel: () => {},
            },
            messageDialog: {
                title: "",
                content: "",
                visible: false,
                showCancel: false,
                confirm: () => {},
                cancel: () => {},
            },
            link: `https://cch.haorich.tw/`
        };
    },
    computed: {
        ...mapGetters(["getUserInfo", "getAgentList"]),
        columnKeys() {
            var list = [{
                    value: "convert",
                    text: "轉申請書",
                    sortable: false,
                    required: false,
                    color: "primary",
                    isEvent: true,
                },
                {
                    value: "view",
                    text: "檢視",
                    sortable: false,
                    required: false,
                    color: "success",
                    isEvent: true,
                },
                {
                    value: "name",
                    text: "申辦人",
                    sortable: true,
                    required: true,
                    isShow: true,
                    isEdit: true,
                },
                {
                    value: "memberId",
                    text: "身分證字號",
                    sortable: false,
                    required: true,
                    isShow: true,
                    isEdit: true,
                },
                {
                    value: "installmentsNumber",
                    text: "總期數",
                    sortable: false,
                    required: true,
                    isShow: true,
                    isEdit: true,
                },
                {
                    value: "totalPrice",
                    text: "貸款金額",
                    sortable: false,
                    required: true,
                    isShow: true,
                    isEdit: true,
                },
                {
                    value: "createdDate",
                    text: "申請日期",
                    sortable: true,
                    required: true,
                    isShow: true,
                    isEdit: true,
                },
            ];
            return list;
        },
        typeKeys() {
            return [
                { key: 0, text: "裕富" },
                { key: 1, text: "和潤" },
                { key: 2, text: "中租" },
            ];
        },
    },
    created() {
        this.setDefualtDate();
    },
    methods: {
        ...mapActions(["originList", "originInfo", "saveFinanceInfo",'saveFinanceCreditData']),
        createLink() {
            window.open(this.link, "_blank");
        },
        cellEvent(props) {
            console.log(`cellEvent ${JSON.stringify(props)}`);
            if (props.key === "edit") {} else if (props.key === "delete") {} else if (props.key === "convert") {
                this.showSelectDialog(props.item);
            } else if (props.key === "view") {
                window.open(`${this.link}#/?caseId=${props.item.caseId}`, "_blank");
            }
        },
        showSelectDialog(item) {
            this.loading = true;
            this.selectDialog.visible = true;
            const self = this
            this.selectDialog.confirm = () => {
                self.convertApplication(item);
                this.loading = false;
            };
            this.selectDialog.cancel = () => {
                self.selectDialog.visible = false;
                this.loading = false;
            };
        },
        async convertApplication(item) {

            this.selectDialog.visible = false;
            const data = {
                isConvert: true,
                caseId: item.caseId,
            };
            const results = await this.originInfo(data);
            const result = results.data.data;

            const copy = JSON.parse(JSON.stringify(result));
            copy.caseId = Math.uuidFast();
            copy.platform = this.selectDialog.type
            copy.agentId = this.getUserInfo.agentId;
            copy.parentAgent = {
              agentId: this.getUserInfo.agentId,
              displayName: this.getUserInfo.displayName,
              parentAgent: this.getUserInfo.parentAgent
            }

            console.log(`copy ${JSON.stringify(copy)}`)
            try {
              const saveResult = await this.saveFinanceInfo(copy);
              const result = saveResult.data;
              console.log(`result ${JSON.stringify(result)}`)
              if (result && result.statusCode === 0){
                this.saveFinanceCreditData(copy);
                this.showMessageDialog('提示', `轉換完成`, true, () => {}, () => {});
              } else {
                this.showMessageDialog('錯誤', `轉換失敗，請聯繫資訊人員。`, true, () => {}, () => {});
              }
            } catch (e) {
              this.showMessageDialog(
                "提示",
                `儲存失敗！${e}，請聯繫資訊人員。`,
                true,
                () => {},
                () => {}
              );
            }
            this.loading = false;
        },
        reset() {},
        setDefualtDate() {
            let todayDate = new Date();
            todayDate.setMonth(todayDate.getMonth() - 1);
            let currentDate = todayDate.toISOString().substr(0, 10);
            const [thisYear, thisMonth, thisDay] = currentDate.split("-");
            this.search.startDate = `${thisYear}-${thisMonth}-01`;

            let futureDate = new Date();
            // 将当前月份加1，下移到下个月
            futureDate.setMonth(futureDate.getMonth() + 1);
            // 再获取天数即取上个月的最后一天的天数
            futureDate.setDate(0);
            let days = futureDate.getDate();

            let endDate = futureDate.toISOString().substr(0, 10);
            const [futureYear, futureMonth, futureDay] = endDate.split("-");

            this.search.endDate = `${futureYear}-${futureMonth}-${days}`;
        },
        changePage(page) {
            // 改變頁數 or 每頁筆數
            this.pageIndex = page.page;
            this.limit = page.rowsPerPage;
            this.loadData();
        },
        async loadData() {
            let results = await this.dataService();
            console.log(`load data = ${JSON.stringify(results)}`);
            this.items = results.data.data.list;
        },
        async dataService(pageIndex = this.pageIndex, limit = this.limit) {
            this.loading = true;
            const data = {
                startDate: `${this.search.startDate} 00:00:00`,
                endDate: `${this.search.endDate}  23:59:59`,
                pageIndex: pageIndex,
                limit: limit,
                searchQuery: [],
            };
            let result = await this.originList(data);
            this.loading = false;
            return result;
        },
        showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {

            this.messageDialog.title = title;
            this.messageDialog.content = text;
            this.messageDialog.visible = visible;
            const self = this;
            this.messageDialog.confirm = () => {
                self.messageDialog.visible = false;
                if (confirmEvent) {
                    confirmEvent();
                }
            };
            this.messageDialog.cancel = () => {
                self.messageDialog.visible = false;
                if (cancelEvent) {
                    cancelEvent();
                }
            };
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/pages/web/CreditLoanList.vue